import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import React, { FunctionComponent, ReactElement } from 'react'
import BodyFont from '../../Theme/Fonts/Body'
import SmallBodyFont from '../../Theme/Fonts/SmallBody'
import { DateType, RowDataProps } from '../Types'

const setColor = (day: DateType, selected: boolean) => {
    if (selected) return 'pearl'
    if (day.key !== 'MONTH_DAY_RANGE' && day.key !== 'DAY_INACTIVE') return 'keshi-3'
    return 'onyx'
}
const DateBlock: FunctionComponent<RowDataProps> = ({
    day,
    dateBlocksDimension,
    dateBlockBorderRadius,
    isMaxSizeApp,
    onPressDateBlock,
    selected,
}): ReactElement => {
    return (
        <Grid minWidth="13.5%" marginBottom={2} height={dateBlocksDimension} center>
            <Touchable
                onPress={
                    !day.key.includes('INACTIVE')
                        ? () => {
                              onPressDateBlock(day)
                          }
                        : undefined
                }
            >
                <Grid
                    height={dateBlocksDimension}
                    key={`calendar-day-${day.value}`}
                    position="relative"
                    minWidth={dateBlocksDimension}
                    flexGrow={1}
                >
                    {day.key.includes('INACTIVE') && (
                        <Grid
                            noExpand
                            position="absolute"
                            top={dateBlocksDimension / 5}
                            left={dateBlocksDimension / 2 - 1}
                            textAlign="center"
                            width={dateBlocksDimension}
                        >
                            <Grid
                                width={2}
                                height={25}
                                rotate={45}
                                position="absolute"
                                backgroundColor="moon-4"
                            />
                            <Grid
                                width={2}
                                height={25}
                                rotate={-45}
                                position="absolute"
                                backgroundColor="moon-4"
                            />
                        </Grid>
                    )}
                    <Grid
                        backgroundColor={selected ? 'onyx' : undefined}
                        borderRadius={dateBlockBorderRadius}
                        border={day.isToday ? '1px' : undefined}
                        center
                        height={dateBlocksDimension}
                        width={dateBlocksDimension}
                        noExpand
                    >
                        <Grid noExpand zIndex={1}>
                            {isMaxSizeApp ? (
                                <BodyFont
                                    color={setColor(day, selected)}
                                >{`${day.value}`}</BodyFont>
                            ) : (
                                <SmallBodyFont
                                    color={setColor(day, selected)}
                                >{`${day.value}`}</SmallBodyFont>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Touchable>
        </Grid>
    )
}

export default DateBlock
